import { render, staticRenderFns } from "./AttendanceTabs.vue?vue&type=template&id=da472e40&scoped=true&"
import script from "./AttendanceTabs.vue?vue&type=script&lang=js&"
export * from "./AttendanceTabs.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceTabs.vue?vue&type=style&index=0&id=da472e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da472e40",
  null
  
)

export default component.exports